import script from "./ProjectProgressCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectProgressCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectProgressCard.vue?vue&type=style&index=0&id=2b6a9d4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6a9d4c"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon,QSpinner});
